const Met = {
    sort: (dataArray, sortColumn, isDesc) => {
        return dataArray.sort((pre, next) => {
            return isDesc ? (next[sortColumn] - pre[sortColumn]) : (pre[sortColumn] - next[sortColumn]);
        });
    },

    numberAndDecimal: (value) => {
        // console.log('$numberAndDecimal-->',value)
        let v = value.replace('。', '.');
        v = v.replace(/[^\d.]/g, '');
        v = v[0] == '.' ? '0.' + v : v;

        let split = v.split('.');

        if (split.length && split.length > 2) {
            let c = '';
            for (let i = 0; i < split.length; i++) {
                c += split[i];
                i == 0 ? c += '.' : '';
            }

            v = c;
        }
        return v;
    },

    // input val filter
    filterNumber: (e) => {
        function clearNoNum(val) {
            // 
            val = val.replace(/[^\d.]/g, '');

            // 
            val = val.replace(/\.{2,}/g, '.');

            // 
            val = val.replace(/^\./g, '');

            //
            val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');

            return val;
        }

        e.target.value = clearNoNum(e.target.value);
    },

    numFormat: (val, flag) => {
        if (!val || !flag) return val;
        let reg = /(\d)(?=(?:\d{3})+$)/g;
        const strAry = val.toString().split('.');
        return `${strAry[0].replace(reg, '$1,')}${strAry.length > 1 ? '.' + strAry[1] : ''}`;
    },

    hash: (txHash, length = 4, lastLength = 6) => {
        if (!txHash) {
            return '--';
        }
        if (!lastLength) lastLength = length;
        return txHash.substring(0, length) + '...' + txHash.substring(txHash.length - lastLength, txHash.length);
    },

    isSameDay: (date1, date2) => {
        return new Date(date1).toDateString() === new Date(date2).toDateString();
    },

    copy: (text) => {
        try {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
        } catch (e) {
            console.error('copy error', e);
        }
    },

    fixJSON: (json) => {
        json = json
            .replace(/(\w+)\s*:/g, '"$1":')
            ?.replace(/},\s*]/g, "}]");
        return JSON.parse(json.replace(
            /("[^"]*"\s*:\s*)([^,"}\]]*\/[\d.]+)([,\]}])/g,
            function (match, p1, p2, p3) {
                return p1 + eval(p2) + p3;
            }
        ));
    },

    $onlyNumber: (val) => {
        return val.replace(/[^\d]/g, '');
    },

    formatDate: (date, format) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");

        if (format === "YYYY-MM") {
            return `${year}-${month}`;
        } else if (format === "YYYY-MM-DD") {
            return `${year}-${month}-${day}`;
        } else {
            return `${year}-${month}-${day}`;
        }
    },

    startDateFromWeek: (year, week) => {
        const date = new Date(year, 0, 1);
        const daysUntilTargetWeek = (week - 1) * 7 - date.getDay() + 1;
        date.setDate(date.getDate() + daysUntilTargetWeek);
        return date;
    },

    convertToTimestamp: (time, format) => {
        if (format === 'weekly') {
            const [year, week] = time.split("-").map(Number);
            const startDate = Met
                .startDateFromWeek(year, week);
            return startDate.getTime();
        } else {
            return new Date(time).getTime()
        }
    }
}

const install = Vue => {
    if (install.installed) return;
    install.installed = true;

    Object.defineProperty(Vue.prototype, '$Met', {
        get() {
            return Met;
        },
    });
};

export default install;
